<template>
  <div class="service-guide">
    <div class="logo-area">
      <a
        href="https://www.008008.jp/"
        target="_blank"
        rel="noopener"
        ><img src="/images/yhc-logo.jpg"
      /></a>
    </div>
    <h1>お問い合わせ</h1>
    <p>Webで解決できなかった疑問もチャットボットがお答えします！</p>
    <div
      class="chat-bot-card"
      @click="chatbotClick"
    >
      <div class="chat-bot-card--icon">
        <img src="/images/chat.png" />
      </div>
      <div class="chat-bot-card--name">チャット形式で質問する</div>
    </div>
    <a
      href="https://supportbot-admin.userlocal.jp/pages/b1d0f7701693110f5901"
      ref="chatbotLink"
      target="_blank"
      rel="noopener"
      @click="sendGAEvent('チャットボット')"
      style="display: none"
    ></a>
    <p class="mb-2">
      利用シーンに応じた申込みや料金シミュレーション、他のサービスについて下記より選択いただけます。
    </p>
    <div class="service-grid">
      <div class="service-card hikkoshi">
        <div
          class="service-grid--title"
          @click="toggleAccordion(hikkoshiMenu)"
        >
          <div>{{ !hikkoshiMenu.isOpen ? '▲' : '▼' }}</div>
          <div class="service-grid--title-main">{{ hikkoshiMenu.title }}</div>
          <div>{{ !hikkoshiMenu.isOpen ? '▲' : '▼' }}</div>
        </div>
        <ul
          v-show="hikkoshiMenu.isOpen"
          class="accordion-content"
        >
          <li
            v-for="(item, index) in hikkoshiMenu.items"
            :key="index"
          >
            <span class="bold">{{ item.title }}</span>
            <ul>
              <li
                v-for="(subItem, subIndex) in item.subItems"
                :key="subIndex"
              >
                <a
                  :href="subItem.href"
                  target="_blank"
                  rel="noopener"
                  @click="sendGAEvent(subItem.ga4SendName)"
                >
                  {{ subItem.text }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="service-card kazai">
        <div
          class="service-grid--title"
          @click="toggleAccordion(kazaiMenu)"
        >
          <div>{{ !kazaiMenu.isOpen ? '▲' : '▼' }}</div>
          <div class="service-grid--title-main">{{ kazaiMenu.title }}</div>
          <div>{{ !kazaiMenu.isOpen ? '▲' : '▼' }}</div>
        </div>
        <ul v-show="kazaiMenu.isOpen">
          <li
            v-for="(item, index) in kazaiMenu.items"
            :key="index"
          >
            <span
              class="bold"
              :style="item.fontSize ? `font-size: ${item.fontSize}` : ''"
              >{{ item.title }}</span
            >
            <ul>
              <li
                v-for="(subItem, subIndex) in item.subItems"
                :key="subIndex"
              >
                <a
                  v-if="!subItem.openModal"
                  :href="subItem.href"
                  target="_blank"
                  rel="noopener"
                  @click="sendGAEvent(subItem.ga4SendName)"
                >
                  {{ subItem.text }}
                </a>
                <div
                  v-else
                  @click="openKazaiModal(subItem)"
                >
                  {{ subItem.text }}
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="service-card kagukadenido">
        <div
          class="service-grid--title"
          @click="toggleAccordion(kagukadenidoMenu)"
        >
          <div>{{ !kagukadenidoMenu.isOpen ? '▲' : '▼' }}</div>
          <div class="service-grid--title-main-small">{{ kagukadenidoMenu.title }}</div>
          <div>{{ !kagukadenidoMenu.isOpen ? '▲' : '▼' }}</div>
        </div>
        <ul v-show="kagukadenidoMenu.isOpen">
          <li
            v-for="(item, index) in kagukadenidoMenu.items"
            :key="index"
          >
            <a
              :href="item.href"
              target="_blank"
              rel="noopener"
              @click="sendGAEvent(item.ga4SendName)"
            >
              {{ item.text }}
            </a>
          </li>
        </ul>
      </div>

      <div class="service-card life">
        <div
          class="service-grid--title"
          @click="toggleAccordion(sonotaMenu)"
        >
          <div>{{ !sonotaMenu.isOpen ? '▲' : '▼' }}</div>
          <div class="service-grid--title-main-small">{{ sonotaMenu.title }}</div>
          <div>{{ !sonotaMenu.isOpen ? '▲' : '▼' }}</div>
        </div>
        <ul v-show="sonotaMenu.isOpen">
          <li
            v-for="(item, index) in sonotaMenu.items"
            :key="index"
          >
            <a
              :href="item.href"
              target="_blank"
              rel="noopener"
              @click="sendGAEvent(item.ga4SendName)"
            >
              {{ item.text }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { $yhcGA4EventSender } from '../YhcEstimateFormFrontPage/YhcGA4EventSender'
import YhcKazaiEntryModal from './YhcKazaiEntryModal.vue'
import '../YhcEstimateFormFrontPage/components/_yhc-estimate-form-front.scss'

export default {
  name: 'YhcServiceInfoPage',
  data() {
    return {
      isMobile: false,
      kazaiModalId: '',
      hikkoshiMenu: {
        isOpen: false,
        title: '引越をしたい',
        items: [
          {
            title: '単身者向け引越し',
            subItems: [
              {
                text: 'わたしの引越しサービスページへ',
                href: 'https://www.008008.jp/moving/single?utm_source=from_sms_to_hikkoshi&utm_medium=sms',
                ga4SendName: 'わたしの引越し_TOP',
              },
              {
                text: 'Web申し込み',
                href: 'https://entry.008008.jp/single/step1?utm_source=from_sms_to_hikkoshi_entry&utm_medium=sms',
                ga4SendName: 'わたしの引越し_Web申し込み',
              },
              {
                text: '料金シミュレーション',
                href: 'https://www.008008.jp/moving/single/before-entry.html?utm_source=from_sms_to_hikkoshi_simulation&utm_medium=sms',
                ga4SendName: 'わたしの引越し_料金シミュレーション',
              },
            ],
          },
          {
            title: '家族向け引越し',
            subItems: [
              {
                text: '※アート引越センターHPへ',
                href: 'https://www.the0123.com/',
                ga4SendName: '家族向け引越し_アート引越センター',
              },
            ],
          },
        ],
      },
      kazaiMenu: {
        isOpen: false,
        title: '大きい荷物を運びたい',
        items: [
          {
            title: '家具・家電',
            subItems: [
              {
                text: '家財おまかせ便サービスページへ',
                openModal: false,
                href: 'https://www.008008.jp/transport/kazai?utm_source=from_sms_to_kazai&utm_medium=sms',
                ga4SendName: '家財おまかせ便_TOP',
              },
              {
                text: '申し込み',
                openModal: true,
                linkInModal: {
                  web: {
                    linkName: 'Web申し込み',
                    pcHref:
                      'https://form.008008.jp/mitumori/PKZI0150Action_doInit.action?utm_source=from_sms_to_kazai_entry&utm_medium=sms',
                    spHref:
                      'https://form.008008.jp/mitumori/SKZI0150Action_doInit.action?utm_source=from_sms_to_kazai_entry&utm_medium=sms',
                    ga4SendName: '家財おまかせ便_Web申し込み',
                  },
                  tel: {
                    linkName: '電話申し込み',
                    href: 'tel:0120774744',
                    ga4SendName: '家財おまかせ便_電話申し込み',
                  },
                },
                href: 'https://form.008008.jp/mitumori/PKZI0150Action_doInit.action?utm_source=from_sms_to_kazai_entry&utm_medium=sms', // エラー回避のためのダミー
                ga4SendName: '家財おまかせ便_申し込み',
              },
              {
                text: '料金日時シミュレーション',
                openModal: false,
                href: 'https://www.008008.jp/transport/kazai/simulation?utm_source=from_sms_to_kazai_simulation&utm_medium=sms',
                ga4SendName: '家財おまかせ便_料金日時シミュレーション',
              },
            ],
          },
          {
            title: '車両・ピアノ(楽器)・ペット・重量物など',
            fontSize: '16px',
            subItems: [
              {
                text: '特殊輸送サービスページへ',
                openModal: false,
                href: 'https://www.008008.jp/transport/others?utm_source=from_sms_to_kazai_other&utm_medium=sms',
                ga4SendName: '特殊輸送_TOP',
              },
            ],
          },
        ],
      },
      kagukadenidoMenu: {
        isOpen: false,
        title: '家屋内で家具・家電を移動したい',
        items: [
          {
            text: '家具・家電移動サービスページへ',
            href: 'https://www.008008.jp/transport/furniture/01?utm_source=from_sms_to_kagukadenido&utm_medium=sms',
            ga4SendName: '家具・家電移動_TOP',
          },
          {
            text: 'Web申し込み',
            href: 'https://reg31.smp.ne.jp/regist/is?SMPFORM=qap-ldsgqd-c9b25cfc89a2e96e2097ef822fa244c9&utm_source=from_sms_to_kagukadenido_entry&utm_medium=sms',
            ga4SendName: '家具・家電移動_Web申し込み',
          },
        ],
      },
      sonotaMenu: {
        isOpen: false,
        title: 'その他・輸送を伴わないサービス',
        items: [
          {
            text: 'よくあるご質問(FAQ)',
            href: 'https://www.008008.jp/faq?utm_source=from_sms_to_faq&utm_medium=sms',
            ga4SendName: 'FAQ',
          },
          {
            text: 'エアコン取付・取外し',
            href: 'https://www.008008.jp/life/electric/aircon/01?utm_source=from_sms_to_life_aircon&utm_medium=sms',
            ga4SendName: 'その他_エアコン取付・取外し',
          },
          {
            text: '照明取付・取外し',
            href: 'https://www.008008.jp/life/electric/light/01?utm_source=from_sms_to_life_light&utm_medium=sms',
            ga4SendName: 'その他_照明取付・取外し',
          },
          {
            text: '洗濯機取付・取外し',
            href: 'https://www.008008.jp/life/electric/washer/01?utm_source=from_sms_to_life_washer&utm_medium=sms',
            ga4SendName: 'その他_洗濯機取付・取外し',
          },
          {
            text: '温水便座取付・取外し',
            href: 'https://www.008008.jp/life/electric/toiletseat/01?utm_source=from_sms_to_life_toiletseat&utm_medium=sms',
            ga4SendName: 'その他_温水便座取付・取外し',
          },
          {
            text: '食器洗い乾燥機取付・取外し',
            href: 'https://www.008008.jp/life/electric/dishwasher/01?utm_source=from_sms_to_life_dishwasher&utm_medium=sms',
            ga4SendName: 'その他_食器洗い乾燥機取付・取外し',
          },
          {
            text: 'アンテナ取付・取外し',
            href: 'https://www.008008.jp/life/electric/antenna/01?utm_source=from_sms_to_life_antenna&utm_medium=sms',
            ga4SendName: 'その他_アンテナ取付・取外し',
          },
          {
            text: 'TV・ホームシアター配線',
            href: 'https://www.008008.jp/life/electric/tv/01?utm_source=from_sms_to_life_tv&utm_medium=sms',
            ga4SendName: 'その他_TV・ホームシアター配線',
          },
          {
            text: 'AV配線',
            href: 'https://www.008008.jp/life/electric/av/01?utm_source=from_sms_to_life_av&utm_medium=sms',
            ga4SendName: 'その他_AV配線',
          },
          {
            text: '畳・障子・ふすまの張り替え',
            href: 'https://www.008008.jp/life/reform/tatami/01?utm_source=from_sms_to_life_tatami&utm_medium=sms',
            ga4SendName: 'その他_畳・障子・ふすまの張り替え',
          },
          {
            text: 'オーダーブラインド',
            href: 'https://www.008008.jp/life/region/reform/blind/01?utm_source=from_sms_to_life_blind&utm_medium=sms',
            ga4SendName: 'その他_オーダーブラインド',
          },
          {
            text: '盗聴器探査サービス',
            href: 'https://www.008008.jp/life/wiretap/02?utm_source=from_sms_to_life_wiretap&utm_medium=sms',
            ga4SendName: 'その他_盗聴器探査サービス',
          },
        ],
      },
    }
  },
  mounted() {
    this.checkDeviceScreenSize()
  },
  methods: {
    // デバイスのスクリーンサイズをチェック
    checkDeviceScreenSize() {
      const width = window.innerWidth
      if (width < 768) {
        this.$nextTick(() => {
          this.isMobile = true
        })
      }
    },
    // 電話番号クリックの確認メッセージ
    async confirmTel(event) {
      if (await $core.$toast.confirmDialog('電話申し込みを行います、よろしいですか？')) {
        window.location.href = event.target.href
      }
    },
    chatbotClick() {
      this.$refs.chatbotLink.click()
    },
    telClick() {
      this.$refs.telLink.click()
    },
    toggleAccordion(menuName) {
      menuName.isOpen = !menuName.isOpen
    },
    openKazaiModal(subItem) {
      $core.$modals.openModal({
        modalId: 'kazaiModal',
        modalProps: {
          size: 'sm',
          centered: true,
          hideFooter: true,
        },
        component: YhcKazaiEntryModal,
        componentProps: {
          item: subItem,
          isMobile: this.isMobile,
        },
      })
    },
    // GA4イベント送信
    sendGAEvent(linkName: string) {
      $yhcGA4EventSender.linkClickFromSmsServiceInfoPage(linkName)
    },
  },
}
</script>
<style scoped lang="scss">
.service-guide {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0px 0px 20px 0px;

  .logo-area {
    width: 60%;
    max-width: 280px;
    min-width: 100px;
    padding: 0.5rem;

    img {
      width: 100%;
    }
  }

  p {
    font-weight: bold;
    margin-bottom: 5px;
    padding: 0px 20px 0px 20px;
  }

  .chat-bot-card {
    display: flex;
    align-items: center;
    margin: 15px;
    width: 100%;
    max-width: calc(30% - 20px);
    border-radius: 40px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
    border: 3px solid var(--yhc-color);
    cursor: pointer;
    overflow: hidden;

    .chat-bot-card--icon {
      flex-shrink: 0;
      padding: 6px;
      width: 70px;
      text-align: center;
      background-color: var(--yhc-color);

      img {
        width: 30px;
      }
    }

    .chat-bot-card--name {
      flex-grow: 1;
      color: var(--yhc-color);
      padding: 9px;
      font-weight: bold;
      font-size: 16px;
      text-align: center;
      letter-spacing: 0.1em;
    }

    .chat-bot-card--name:hover {
      background-color: var(--yhc-color);
      color: white;
    }
  }

  @media (max-width: 600px) {
    .chat-bot-card {
      max-width: calc(100% - 40px);
      margin: 15px auto;
    }
  }

  .service-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: left;
    padding: 0px 20px 0px 20px;

    .service-card {
      width: calc(30% - 10px);
      //border-top-left-radius: 40px;
      //border-top-right-radius: 40px;
      border-radius: 40px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);

      .service-grid--title {
        cursor: pointer;
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 50px;
        padding: 5px;
        margin-bottom: 15px;
        text-align: center;
        font-weight: bold;
        border-bottom: white 1px solid;

        .service-grid--title-main {
          font-size: 20px;
        }

        .service-grid--title-main-small {
          font-size: 16px;
        }
      }
    }

    .service-card ul {
      font-size: 18px;
    }

    .service-card li {
      margin: 10px 0px 10px 0px;

      div {
        text-decoration: underline;
        cursor: pointer;
      }

      div:hover {
        color: black;
      }
    }

    .service-card a:hover {
      text-decoration: underline;
    }

    .hikkoshi {
      background-color: var(--yhc-color);
      color: white;

      a {
        color: white;
      }

      a:hover {
        color: black;
      }
    }

    .kazai {
      background-color: var(--yhc-color);
      color: white;

      a {
        color: white;
      }

      a:hover {
        color: black;
      }
    }

    .kagukadenido {
      background-color: var(--yhc-color);
      color: white;

      a {
        color: white;
      }

      a:hover {
        color: black;
      }
    }

    .life {
      background-color: var(--yhc-color-gray);
      color: white;

      a {
        color: white;
      }

      a:hover {
        color: black;
      }
    }

    @media (max-width: 600px) {
      .service-card {
        width: 100%;
      }
    }
  }
}

h1 {
  background-color: var(--yhc-color-gray);
  color: white;
  padding: 10px;
  text-align: center;
}
</style>
